export default __webpack_public_path__ + "static/media/girls.ab3c03ac.jfif";